import React from 'react';
import moment from 'moment';

class RowItemChiTietThanhVienCuocThanhTraView  extends React.Component {

  render() {
    let Data = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{Data.hoVaTen ? Data.hoVaTen : ''}</td>
        <td>{Data.ngaySinh ? moment(Data.ngaySinh).format('DD/MM/YYYY') : ''}</td>
        <td>{Data.donVi ? Data.donVi : ''}</td>
        <td>{Data.chucVu ? Data.chucVu : ''}</td>
        <td>{Data.vaiTroThanhVienDoanInfo ? Data.vaiTroThanhVienDoanInfo.text : ''}</td>
      </tr>
    );
  }
}

export default RowItemChiTietThanhVienCuocThanhTraView;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemChiTietThanhVienCuocThanhTraView.jsx